import { FromSchema, ZodDate } from '@40seas/entities/common';
import { z } from 'zod';

export const TimelineValueSchema = z
    .object({
        updatedAt: ZodDate,
    })
    .strict();

export class TimelineValue extends FromSchema(TimelineValueSchema) {
    updatedAt: Date;
}
